import { doMutation } from "../../core-module/util/graphqlHelper";

export const submitQuizContentForApproval = ({ id }) => {
  const mutation = require("../api/mutation/submitQuizContentForApproval.gql");
  const variables = { id };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.submitQuizContentForApproval };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
